import { ElMessage } from 'element-plus'

export const offer = {
    state: () => ({
        offer: {}
    }),
    getters: {
        offer({offer}){
            return offer
        }
    },
    mutations:{
        offer(state,payload){
            state.offer = payload
        }
    },
    actions:{
        async getOffer({dispatch,commit}){
            let res = await dispatch('getAxios',{
                url: 'offer'
            })
            if (res.status === 200){
                commit('offer',{...res.data})
            }
        },
        async saveOffer({dispatch,commit},payload){
            let res = await dispatch('putAxios',{
                url: 'offer',
                data: payload
            })
            if (res.status === 200){
                commit('offer',{...res.data})
                ElMessage({
                    message: 'Oferta matni yangilandi',
                    type: 'success',
                })
            }
        }
    }
}